import { ScreenContainerControl } from "doshx_controls_web";
import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { client_policy } from "../../api/calls/client/policy";
import { setMainModal } from "../../reducers/slices/main";
import { useDispatch } from "react-redux";
export const PrivacyPolicyPage = (props) => {
    const dispatch = useDispatch();
    const [privacyData, setPrivacyData] = useState("");
    useEffect(() => {
        client_policy().then((response) => {
            if (response.success) {
                setPrivacyData(response.content.policy);
            }
            else {
                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    }, []);
    return (React.createElement("div", { className: "" },
        React.createElement(ScreenContainerControl, null,
            React.createElement("div", { className: "flex flex-col gap-4" },
                React.createElement(ReactMarkdown, null, privacyData)))));
};
